"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("../constants");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Command = /*#__PURE__*/function () {
  function Command(store, name) {
    _classCallCheck(this, Command);

    _defineProperty(this, "status", _constants.COMMAND_STATUSES.ACTIVE);

    _defineProperty(this, "store", null);

    _defineProperty(this, "name", null);

    this.store = store;
    this.name = name;
  }

  _createClass(Command, [{
    key: "perform",
    value: function perform() {
      this.status = _constants.COMMAND_STATUSES.IN_PROGRESS;
    }
  }, {
    key: "complete",
    value: function complete() {
      this.status = _constants.COMMAND_STATUSES.COMPLETED;
    }
  }, {
    key: "isActive",
    get: function get() {
      return this.status === _constants.COMMAND_STATUSES.ACTIVE;
    }
  }, {
    key: "isCompleted",
    get: function get() {
      return this.status === _constants.COMMAND_STATUSES.COMPLETED;
    }
  }]);

  return Command;
}();

exports["default"] = Command;